import {useStickerCanvas} from '~/common/canvas/hooks/useStickerCanvas';
import linerShading from '~images/liner_shading.png';
import './Premium.sass';

export const MainAssetSlide = ({
  envelope,
  containerHeight,
  stamp,
  inviteName,
  liner,
  inviteContainerRef,
  desktopInviteRef,
  envelopeWidthRef,
  stickerContainerRef,
  envelopeStickers,
  children,
}) => {
  const {canvasRef} = useStickerCanvas({
    configJson: envelopeStickers,
    onChange: () => null,
    setCanvas: () => null,
  });

  return (
    <div className="asset">
      <div
        className="desktop-invite-container"
        ref={desktopInviteRef}
        style={{
          height: containerHeight,
        }}
      >
        <div className="invite-container step-0 fabric" ref={inviteContainerRef}>
          <div className="invite-animation open-flap">
            <div className="animation-image invite-envelope__open-flap-group">
              <img
                className="invite-envelope__open-flap invite-envelope__open-flap-shading"
                src={linerShading}
                alt=""
              />
              <img className="invite-envelope__open-flap" src={envelope.openBack} alt="" />
              <img className="invite-envelope__top-liner" src={liner.image} alt="" />
            </div>
          </div>

          <div className="invite-animation your-invitation">
            <div className="animation-image invite-envelope__your-invitation fabric">
              <div className="invite-envelope__your-invitation__card">{children}</div>
            </div>
          </div>

          <div className="invite-animation open-bottom-front">
            <img
              ref={envelopeWidthRef}
              className="animation-image invite-envelope__open-bottom-front"
              src={envelope.openBack}
              alt="Envelope Open Bottom Front"
            />
          </div>

          <div className="invite-animation closed-flap">
            <div className="animation-image invite-envelope__closed-flap">
              <img
                className="invite-envelope__full-width"
                src={envelope.closedBack}
                alt="Envelop Open Full Width"
              />
            </div>
          </div>

          <div className="invite-animation closed-front">
            <div className="animation-image invite-envelope__closed-front">
              <img
                className="invite-envelope__full-width"
                src={envelope.closedFront}
                alt="Envelope Full Width"
              />
              <img className="invite-envelope__stamp" src={stamp.image} alt="Envelope Stamp" />
              <span
                style={{
                  color: envelope.name?.color,
                  fontFamily: envelope.name?.font,
                }}
                className="invite-envelope__guest-name"
              >
                {inviteName}
              </span>
              <div
                id="canvas__wrapper__stickers"
                className="invite-envelope__closed-front__wrapper__canvas"
                ref={stickerContainerRef}
              >
                <canvas ref={canvasRef} />
              </div>
            </div>
          </div>

          <div className="invisible-width-box">
            <img src={envelope.openBack} alt="Envelope Open Back" />
          </div>
        </div>
      </div>
    </div>
  );
};
